const getTimeDifference = (_dateIn, _dateOut) => {
    const _duration = _dateOut.diff(_dateIn, 'seconds');
    let _str = "";

    if (_duration < 60) {
        _str = _duration + " segundo" + (_duration > 1 ? 's' : '');
    } else {
        const
            _days = _dateOut.diff(_dateIn, 'days'),
            _hours = _dateOut.diff(_dateIn, 'hours') - (_days * 24),
            _minutes = _dateOut.diff(_dateIn, 'minutes') - (_days * 24 * 60) - (_hours * 60),
            _seconds = _dateOut.diff(_dateIn, 'seconds') - (_days * 24 * 60 * 60) - (_hours * 60 * 60) - (_minutes * 60);
 
        if (_days > 0) {
            _str += `${_days} día${(_days > 1 ? 's' : '')}, `;
        }

        if (_hours > 0) {
            _str += `${_hours} hora${(_hours > 1 ? 's' : '')}, `;
        }

        if (_minutes > 0) {
            _str += `${_minutes} minuto${(_minutes > 1 ? 's' : '')}, `;
        }

        if (_seconds > 0) {
            _str += `${_seconds} segundo${(_seconds > 1 ? 's' : '')}`;
        }
    }

    return _str;
}

export default getTimeDifference;